export default {
      id: "sensors__co2_level-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__co2_level",
      toString: function () {
        return this.url;
      }
    }